import React from 'react';

const RateOutFitCard = (props) => {

  const cardStyle = {zIndex: 2 }
  if(props.noShadow){
    cardStyle.boxShadow = 'none' 
  }

 return (
  <div className="fineryCard whiteCard" style={cardStyle}>
    <div className="fineryLocation"><b></b><div>{props.location}</div></div>
    <div className="fineryCardContent">
      <div className="outfitImage" style={{ backgroundImage: `url(${props.imageurl})` }} ></div>
    </div>
    {props.children}
  </div>
  )
}
export default RateOutFitCard;



// WEBPACK FOOTER //
// ./src/templates/RateOutFitCard.js